
import { Link } from 'react-router-dom';

export default function TopBar() {
  return (
    <div className="bg-gray-900 text-gray-400 text-xs py-2 border-b border-gray-800">
      <div className="container mx-auto px-6 flex justify-between items-center">
        <div className="flex space-x-4 items-center">
          <Link to="/" className="flex items-center hover:text-white transition-colors cursor-pointer">
            <i className="fas fa-building mr-1"></i> KR Corp
          </Link>
          <span className="hidden md:inline">|</span>
          <a href="mailto:recruit@krstudio.com?subject=채용 문의" className="hidden hover:text-white transition-colors cursor-pointer">채용</a>
        </div>
        <div className="flex space-x-4">
          <a href="#news" className="hover:text-white transition-colors cursor-pointer">News</a>
          <a href="#family" className="hover:text-white transition-colors cursor-pointer">Family Site</a>
          <a href="#eng" className="hidden text-white hover:text-gray-300 transition-colors cursor-pointer">ENG</a>
        </div>
      </div>
    </div>
  );
}
